import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import pkg from './package.json';

export const { version } = pkg;

export default globalContext.define(
  pkg.legacyDependencies,
  Promise => import(/* webpackMode: 'eager' */ './src/index') // eslint-disable-line no-unused-vars
);
